import { APPX_JP_SITE_URL, APPX_SITE_URL, TBID_LOGIN_AUTH_PROVIDER, TBID_SIGNUP_AUTH_PROVIDER } from '~/modules/config';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { ListingResponse } from '~/modules/services/listing_service';
import { http } from '~/modules/utilities/http';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';
import { generateListingUrl } from '~/modules/utilities/listing_utils';
import { upsertQueryParams } from '~/modules/utilities/router';

export function generateBaseUrl(): string {
    if (getUserLanguage() === JAPANESE_LANGUAGE_CODE) {
        return APPX_JP_SITE_URL || APPX_SITE_URL;
    }
    return APPX_SITE_URL;
}

export function generateTbidLoginUrl(): string {
    const baseUrl = generateBaseUrl();
    return `${baseUrl}${TBID_LOGIN_AUTH_PROVIDER}`;
}

export function generateTbidSignUpUrl(): string {
    const baseUrl = generateBaseUrl();
    return `${baseUrl}${TBID_SIGNUP_AUTH_PROVIDER}`;
}

export function generateLegacyListingUrl(listing?: ListingResponse | null) {
    const url = generateListingUrl(generateBaseUrl(), listing, upsertQueryParams(['legacy', 'true']));
    return url;
}

type FooterAndHeaderEndpoint = 'nav' | 'footer';

function generateFooterAndHeaderUrl(endpoint: FooterAndHeaderEndpoint) {
    // we only want the extra explore flag for nav
    if (endpoint === 'nav') {
        return `${generateBaseUrl()}/${endpoint}?explore`;
    }
    return `${generateBaseUrl()}/${endpoint}`;
}

export async function fetchFooterAndHeaderContent(endpoint: FooterAndHeaderEndpoint) {
    try {
        // W-12473405: Remove the correlationId header that is causing CORS issues when running in localhost.
        // It's not useful to track failures in this endpoint by logging the correlation ID anyway.
        const response = await http.get(generateFooterAndHeaderUrl(endpoint), {
            includeCorrelationIdHeader: false,
        });
        const responseData = response.data;
        return responseData;
    } catch (error) {
        console.error(`failed to pull content ${error}`);
        return '';
    }
}
